import { createFileRoute } from "@tanstack/react-router"

import { About } from "@/components/landing/About"
import { Contact } from "@/components/landing/Contact"
import { Disclaimer } from "@/components/landing/Disclaimer"
import { Faq } from "@/components/landing/Faq"
import { Hero } from "@/components/landing/Hero"
import { HowItWorks } from "@/components/landing/HowItWorks"
import { Services } from "@/components/landing/Services"
import { WhyUse } from "@/components/landing/WhyUse"
import { OrganizationJsonLd } from "@/components/seo/OrganizationJsonLd"
import { Seo } from "@/components/seo/Seo"

export const Route = createFileRoute("/")({
	component: Home,
})

function Home() {
	return (
		<div className="flex flex-col">
			<Seo
				title="Swamithra"
				description="Swamithra connects individual taxpayers and Chartered Accountants with a panel of tax experts who explain your income-tax notice, answer your questions, and review your draft response before you file — privately and over WhatsApp."
				path="/"
			/>
			<OrganizationJsonLd />
			<Hero />
			<About />
			<Services />
			<HowItWorks />
			<WhyUse />
			<Faq />
			<Contact />
			<Disclaimer />
		</div>
	)
}
